var getColumnsText = function (columns) {
    return columns.map(function (column) { return (column.attributes && column.attributes.text) || ''; });
};
var convertExternalsToRowsCols = function (list, column, rowsCurIndex) {
    var columns = getColumnsText(column);
    return list
        .map(function (item) {
        var externalItems = [], rowIndex = rowsCurIndex.toString(), rowData = { row: rowIndex };
        for (var _i = 0, _a = Object.entries(item); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            var colIndex = columns.indexOf(key), externalItem = {};
            if (colIndex > -1) {
                externalItem['row'] = rowIndex;
                externalItem['column'] = colIndex.toString();
                externalItem['attributes'] = { text: value };
                externalItem['selected'] = item[key + "_selected"];
                externalItems.push(externalItem);
            }
            else {
                rowData[key] = value;
            }
        }
        ++rowsCurIndex;
        return { itemData: externalItems, rowData: rowData };
    })
        .reduce(function (accum, curr) {
        var _a;
        (_a = accum.itemData).push.apply(_a, curr.itemData);
        accum.rowData.push(curr.rowData);
        return accum;
    }, { itemData: [], rowData: [] });
};
var getExistingRowHeight = function (item) {
    var itemsLength = (item && item.length) || 0;
    return itemsLength;
};
var gridData = function (externalValues, item, column, identifier) {
    var _a, _b;
    if (externalValues === void 0) { externalValues = {}; }
    var existingItemsLength = getExistingRowHeight(item);
    var mergedTable = { itemData: item || [], rowData: [] };
    for (var _i = 0, _c = Object.entries(externalValues); _i < _c.length; _i++) {
        var _d = _c[_i], key = _d[0], value = _d[1];
        if (key === identifier) {
            var externalItems = value;
            var itemsWithRowsCols = convertExternalsToRowsCols(externalItems, column, existingItemsLength);
            console.log('====itemsWithRowsCols', itemsWithRowsCols);
            (_a = mergedTable['itemData']).push.apply(_a, itemsWithRowsCols['itemData']);
            (_b = mergedTable['rowData']).push.apply(_b, itemsWithRowsCols['rowData']);
        }
    }
    return mergedTable;
};
export default gridData;
//# sourceMappingURL=gridData.js.map